import React, { useMemo, useState } from 'react';

import { useTypedSelector } from '@/store/store';
import { selectBlogPostList } from '@/store/reducers/tager/blog';
import { QUERY_DEFAULT_VALUES } from '@/constants/catalog';

import PostsView from './PostsView';
const Posts = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const posts = useTypedSelector(selectBlogPostList);

  const filteredPosts = useMemo(() => {
    if (posts.length > 0) {
      return posts.slice(
        (currentPage - 1) * QUERY_DEFAULT_VALUES.PageLimit,
        QUERY_DEFAULT_VALUES.PageLimit * currentPage
      );
    }
    return [];
  }, [currentPage, posts]);

  return (
    <PostsView
      posts={filteredPosts}
      currentPage={currentPage}
      onPageChange={setCurrentPage}
      totalPage={posts.length}
    />
  );
};

export default Posts;
